import { get, url } from '../../service/ApiWebDecorator'

// 定制需求页面接口
class CustomPage {
  // 笕文获取月份
  @url('/v3/custom/jwxx/listMonth')
  @get
  listMonth() {}

  // 笕文-分页查询未提交月报的教师
  @url('/v3/custom/jwxx/pageNotSubmitTea')
  @get
  pageNotSubmitTea() {}
}

export default new CustomPage()
